import { css } from '@emotion/react'
import InfoIcon from '@mui/icons-material/Info'

import {
  blueTextColor,
  lightBlueBackground,
  primaryTextColor
} from '../../../../../lib/styles/colors'
import { captionTextCss } from '../../../../../lib/styles/typography'

const bannerCss = css`
  background: ${lightBlueBackground};
  display: flex;
  align-items: start;
  justify-content: start;
  padding: 10px;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 16px;
`

const iconContainerCss = css`
  color: ${blueTextColor};
  display: flex;
  align-items: center;
  padding-right: 10px;
  padding-top: 2px;
`

const textCss = css`
  ${captionTextCss}
  color: ${primaryTextColor};
`

const CommentTemplateBanner = () => (
  <div css={bannerCss} aria-live="polite">
    <div css={iconContainerCss}>
      <InfoIcon style={{ fontSize: 14 }} />
    </div>
    <div css={textCss}>
      Comments added to a template will not be able to be deleted when applied to a student’s plan.
    </div>
  </div>
)

export default CommentTemplateBanner
